import { useStore } from '@nanostores/react';
import { accountStore } from '@/services/auth/store';
import { isBuilderPlan } from '@/services/auth/plan-slugs';
import { redirect, useLocation } from '@tanstack/react-router';
import { createElement } from 'react';
import Journeys from '@/pages/journeys';
import { SafeNavigate } from '@/services/router/safe-navigate';
import { AccountFeatureFlag, hasFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';

type CampaignExperimentRedirectInput = {
  location: { pathname: string; hash: string };
};

/** One legacy A/B test's results, which the native Tests page doesn't serve. */
const LEGACY_TEST_RESULTS = /\/overview\/tests\/\d+\/?$/;

export function campaignExperimentRedirect() {
  return ({ location }: CampaignExperimentRedirectInput) => {
    if (!hasFeatureFlag(AccountFeatureFlag.ExperimentAction) || isBuilderPlan(accountStore.get())) return;
    if (LEGACY_TEST_RESULTS.test(location.pathname)) return;
    throw redirect({
      // Parent routes run before their children, so retain the entire nested path.
      to: location.pathname.replace('/journeys/', '/'),
      search: true,
      hash: location.hash,
    });
  };
}

export function CampaignExperimentLegacyRoute() {
  const location = useLocation();
  const isEnabled = useFeatureFlag(AccountFeatureFlag.ExperimentAction);
  const account = useStore(accountStore);
  return isEnabled && !isBuilderPlan(account)
    ? createElement(SafeNavigate, {
        to: location.href.replace('/journeys/', '/'),
        options: { shouldReplaceHistoryEntry: true },
      })
    : createElement(Journeys);
}
